// Models
import { ExternalPlanSource } from "./ExternalPlanSource";
import { isGraphExternalPlanResource } from "../../../../service/graph-legacy/plan/creationSource/IGraphExternalPlanSourceResource";
/**
 * Creation source information for the plan
 */ export class PlanCreationSource {
    static fromGraphResource(resource) {
        if (isGraphExternalPlanResource(resource)) {
            return new PlanCreationSource(ExternalPlanSource.fromResource(resource));
        }
        throw new Error("Unexpected creationSourceKind");
    }
    toGraphSerializable() {
        if (this.external) {
            return this.external.toGraphSerializable();
        }
        return undefined;
    }
    /**
     * Initialize an instance of the creation source information for a plan
     * @param external Information for plans created from an external source
     */ constructor(external){
        if (external != null) {
            this.external = external;
        }
    }
}
